<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs class="mb-0 pb-0" fluid style="padding: 0px;">
        <v-layout row style="padding: 0px;">
          <v-flex md6>
            <v-text-field
              ref="form"
              class="mr-1"
              prepend-icon="search"
              label="Search by Card No and Trx #."
              v-model="searchItem"
              clearable
              hide-details
            ></v-text-field>
            <!-- <search-field @search="search"></search-field> -->
          </v-flex>
          <v-spacer></v-spacer>
          <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
          ></v-select> -->
          <v-tooltip>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="playData()"
            >
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <span>Generate</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="alignAllTransaction()"
            >
              <!-- <v-icon dark><path  /></v-icon>
             -->
              <svg
                style="width:24px;height:24px"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffff"
                  d="M13 5C15.21 5 17 6.79 17 9C17 10.5 16.2 11.77 15 12.46V11.24C15.61 10.69 16 9.89 16 9C16 7.34 14.66 6 13 6S10 7.34 10 9C10 9.89 10.39 10.69 11 11.24V12.46C9.8 11.77 9 10.5 9 9C9 6.79 10.79 5 13 5M20 20.5C19.97 21.32 19.32 21.97 18.5 22H13C12.62 22 12.26 21.85 12 21.57L8 17.37L8.74 16.6C8.93 16.39 9.2 16.28 9.5 16.28H9.7L12 18V9C12 8.45 12.45 8 13 8S14 8.45 14 9V13.47L15.21 13.6L19.15 15.79C19.68 16.03 20 16.56 20 17.14V20.5M20 2H4C2.9 2 2 2.9 2 4V12C2 13.11 2.9 14 4 14H8V12L4 12L4 4H20L20 12H18V14H20V13.96L20.04 14C21.13 14 22 13.09 22 12V4C22 2.9 21.11 2 20 2Z"
                />
              </svg>
            </v-btn>
            <span>Align All Transactions</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel()"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadPDF()"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z"
                />
              </svg>
            </v-btn>
            <span>Download PDF File</span>
          </v-tooltip>
          <refresh-button @refresh="refreshData()"></refresh-button>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px;" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                lazy
                :disabled="queryParams.search ? true : false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :disabled="queryParams.search ? true : false"
                  v-model="dateFrom"
                  label="Pick a Date"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container fluid class="pa-2">
          <v-layout row>
            <!-- <v-flex sm4 md4 class="pl-0">
              <v-btn @click="openFilterExpansion">
                <v-icon class="mr-3">
                  {{ openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
                </v-icon>
                <span>Filter {{ title }}</span>
              </v-btn>
            </v-flex> -->
            <v-flex sm8 md8></v-flex>
            <v-flex sm12 md12>
              <v-container class="py-2 pr-0" fluid>
                <v-layout row align-center>
                  <v-flex xs12 sm8 md9 class="py-0">
                    <v-layout row align-center>
                      <v-flex xs6 md10 md11 class="px-0">
                        <p
                          class="text-xs-right grey--text caption"
                          style="font-size: 14px; margin-top: 14px; margin-right: 10px;"
                        >
                          Row per Page:
                        </p>
                      </v-flex>
                      <v-flex xs6 sm2 md1 class="text-xs-center">
                        <v-layout row align-center>
                          <v-flex xs7 sm12>
                            <v-select
                              style="font-size: 14px;"
                              :items="page"
                              class="grey--text"
                              id="selected"
                              v-model="pageLimit"
                              @input="limitClick"
                              dense
                              height="20px"
                            ></v-select>
                            <!-- :disabled="this.items.length < 10 ? true : false" -->
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm4 md3 class="py-0">
                    <v-layout row align-center>
                      <v-flex xs6 sm6 class="px-0 pl-3">
                        <p
                          class="text-xs-center grey--text caption"
                          style="font-size: 14px; margin-top: 14px;"
                        >
                          {{ itemFrom + " -" + itemTo + " of " }}
                          {{ totalItems }}
                        </p>
                      </v-flex>
                      <v-flex xs6 sm6>
                        <v-layout row style="padding-right: 100px;">
                          <v-flex sm6 class="mr-3 pl-0">
                            <v-btn
                              fab
                              light
                              small
                              flat
                              @click="backClick"
                              :disabled="disabledBack"
                            >
                              <v-icon dark>chevron_left</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex sm6>
                            <v-btn
                              fab
                              light
                              small
                              flat
                              @click="nextClick"
                              :disabled="disabledNext"
                            >
                              <v-icon dark>chevron_right</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>

        <v-divider></v-divider>
        <!-- :openFilter="openFilter" -->
        <filter-panel openFilter>
          <v-flex md4>
            <v-select
              v-model="filterTransactionReport"
              :items="filterTransactionReports"
              label="ALIGNED"
              solo
              required
            ></v-select>
          </v-flex>
        </filter-panel>
      </v-container>

      <transaction-reports
        :items="items"
        :title="title"
        :tableStyle="theTableStyle"
        :headers="theActualHeaders"
        style="padding: 0px;"
        @sync="syncToWireless"
      ></transaction-reports>

      <message-dialog
        :dialog="messageDialog"
        :title="messageTitle"
        :message="messageText"
        @save="action === 'align' ? saveAlignTransaction() : ''"
        @close="closeMessageDialog"
        :loading="messageLoading"
      ></message-dialog>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
import TransactionReports from "@/components/tripko/ExceptionReports/TransactionReports";
import JsPdf from "jspdf";
import "jspdf-autotable";
var now = new Date();

export default {
  components: {
    TransactionReports,
  },
  data() {
    return {
      openFilter: false,
      filterTransactionReport: { text: "ALIGNED", value: true },
      filterTransactionReports: [
        { text: "ALIGNED", value: true },
        { text: "UNALIGNED", value: false },
      ],
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "12:00",
      theTableStyle: false,
      tableItems: [
        {
          text: "Default Table",
          value: false,
        },
        {
          text: "Grid Style Table",
          value: true,
        },
      ],

      title: "Transaction Alignment",
      headers: [
        // { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Merchant Code",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Branch",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "TRX #",
          align: "center",
          value: "transaction_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "left",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Time",
          align: "center",
          value: "km_post_id",
          sortable: false,
        },
        {
          text: "Trace No. Wireless",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. Wireless",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type Wireless",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount Wireless",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Trace No. Sync",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. Sync",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type Sync",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount Sync",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Discrepancy",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Cashier Name",
          align: "left",
          value: "cashier_name",
          sortable: false,
        },
      ],
      theActualHeaders: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        { text: "", align: "center", value: "action", sortable: false },
        {
          text: "Merchant Code",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Branch",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "TRX #",
          align: "center",
          value: "transaction_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Time",
          align: "center",
          value: "km_post_id",
          sortable: false,
        },
        {
          text: "Trace No. (W)",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. (W)",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type (W)",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount (W)",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Trace No. (S)",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. (S)",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type (S)",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount (S)",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Discrepancy",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Cashier Name",
          align: "left",
          value: "cashier_name",
          sortable: false,
        },
      ],
      vehicleHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
      ],
      items: [],
      vehicleItems: [],
      queryParams: {
        search: "",
        transaction_id: null,
        offset: 0,
        limit: 10,
        type: null,
        aligned: true,
        date_from: null,
        date_to: null,
      },
      dialogType: "",
      dialogColor: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: true,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 100, value: 100 },
      ],
      selected: [],
      addDialog: false,

      subscribeDialog: false,
      assignItems: [],
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      subcompanies: [],
      vehicleTypes: [],
      filterTypes: [
        {
          text: "BOOK",
          value: 1,
        },
        {
          text: "REBOOK",
          value: 2,
        },
        {
          text: "CANCEL",
          value: 3,
        },
        {
          text: "REFUND",
          value: 4,
        },
        {
          text: "REPRINT",
          value: 5,
        },
        {
          text: "BAGGAGE",
          value: 6,
        },
      ],
      filterType: null,
      menu: false,
      menu1: false,
      date_from: this.$dateFormat(now, "YYYY-MM-DD"),
      date_to: this.$dateFormat(now, "YYYY-MM-DD"),
      play_status: false,
      downLoading: false,
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false,
      action: "",
      body: {},
    };
  },
  created: function() {
    this.resetTable();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
    dateFrom: {
      get() {
        this.queryParams.date_from = this.date_from;
        return this.date_from;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_from = value;
        this.date_from = value;
      },
    },
    dateTo: {
      get() {
        this.queryParams.date_to = this.date_from;
        return this.date_to;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_to = value;
        this.date_to = value;
      },
    },
  },
  watch: {
    filterTransactionReport: async function() {
      this.resetTable();

      if (
        this.filterTransactionReport !== null &&
        this.filterTransactionReport !== undefined &&
        this.filterTransactionReport !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.aligned = this.filterTransactionReport;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.aligned = true;
      }
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;

      this.queryParams.date_from = data ? null : this.date_from;
      this.queryParams.date_to = data ? null : this.date_to;
      this.queryParams.aligned = null;
    },
    async getData() {
      this.$clearInfoBar();
      this.items.length = 0;
      this.$store.dispatch("startLoading");

      try {
        // Query Data
        let response = (
          await Services.getTransactionWirelessAndSync(this.queryParams)
        ).data;

        // Assign the reponse data to items to be display on table
        this.items = this.items.concat(response.data);

        this.totalItems = response.count;

        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async playData() {
      this.items = [];

      this.resetTable();

      // this.$refs.form.reset();

      this.play_status = true;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    refreshData() {
      this.date_from = this.$dateFormat(now, "YYYY-MM-DD");
      this.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.$refs.form.reset();
      this.items = [];

      this.resetTable();
    },
    resetTable() {
      this.queryParams.limit = 10;
      this.queryParams.offset = 0;

      this.play_status = false;
    },
    async loadMore() {
      if (!this.play_status) return;

      this.queryParams.offset += this.queryParams.limit;

      if (this.queryParams.offset >= this.totalItems) return;

      await this.getData();
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
    // async openFilterExpansion() {
    //   this.openFilter = await !this.openFilter;
    //   await this.setFilterTransactionReport();
    // },

    async downloadExcel() {
      this.$store.dispatch("startLoading");

      let items = [];

      try {
        const response = (
          await Services.getTransactionWirelessAndSync({
            search: this.queryParams.search,
            transaction_id: this.queryParams.transaction_id,
            offset: 0,
            type: this.queryParams.type,
            aligned: this.queryParams.aligned,
            date_from: this.queryParams.date_from,
            date_to: this.queryParams.date_to,
          })
        ).data;

        items = response.data;
      } catch (error) {}

      this.$store.dispatch("endLoading");

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      dataToDownload.push(header);

      for (let e = 0; e < items.length; e++) {
        let theItem = [];

        theItem.push(items[e].merchant === null ? "--" : items[e].merchant),
          theItem.push(
            items[e].device_serial === null ? "--" : items[e].device_serial
          ),
          theItem.push(items[e].terminal === null ? "--" : items[e].terminal),
          theItem.push(
            items[e].transaction_no === null ? "--" : items[e].transaction_no
          ),
          theItem.push(
            items[e].transaction_date === null
              ? "--"
              : this.$dateFormat(items[e].transaction_date, "YYYY-MM-DD")
          ),
          theItem.push(
            items[e].transaction_time === null
              ? "--"
              : this.$dateFormat(items[e].transaction_date, "HH:mm:ss")
          ),
          theItem.push(
            items[e].trace_no_wireless === null
              ? "--"
              : items[e].trace_no_wireless
          ),
          theItem.push(
            items[e].card_no_wireless === null
              ? "--"
              : items[e].card_no_wireless
          ),
          theItem.push(
            items[e].type_wireless === null
              ? "--"
              : items[e].type_wireless.toUpperCase()
          ),
          theItem.push(
            items[e].card_amount_wireless === null
              ? "--"
              : items[e].card_amount_wireless
          ),
          theItem.push(
            items[e].trace_no_sync === null ? "--" : items[e].trace_no_sync
          ),
          theItem.push(
            items[e].card_no_sync === null ? "--" : items[e].card_no_sync
          ),
          theItem.push(
            items[e].type_sync === null
              ? "--"
              : items[e].type_sync.toUpperCase()
          ),
          theItem.push(
            items[e].card_amount_sync === null
              ? "--"
              : items[e].card_amount_sync
          ),
          theItem.push(
            items[e].discrepancy === null ? "--" : items[e].discrepancy
          ),
          theItem.push(
            items[e].cashier_name ? items[e].cashier_name.toUpperCase() : "--"
          );
        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    async syncToWireless(data) {
      this.messageDialog = true;
      this.messageTitle = "Wireless and Sync Transaction";
      this.messageText =
        "Are you sure you want to align Wireless to Sync Transaction?";
      this.action = "align";
      this.body = { transaction_id: data.id };
    },
    closeMessageDialog() {
      this.messageDialog = false;
    },
    async saveAlignTransaction() {
      this.messageLoading = true;

      try {
        const response = await Services.transactionSyncToWireless(this.body);

        if (response.status === 201 || response.status === 204) {
          this.closeMessageDialog();
          await this.playData();

          this.$infoBar({
            type: "success",
            text: "Sync and Wireless has been aligned.",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeMessageDialog();

        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.data) {
            if (error.response.data.detail) {
              if (error.response.data.detail.code) {
                if (error.response.data.detail.code === "23503") {
                  this.$infoBar({
                    type: "error",
                    text: "Please align Shift Wireless and Shift Sync first.",
                  });
                }
              }
            }
          }
        }
      }

      this.messageLoading = await false;
    },

    async alignAllTransaction() {
      this.messageLoading = true;

      const datas = this.items.filter((data) => {
        return data.transaction_status != 0;
      });
      let alignIDS = [];

      datas.forEach(async (item) => {
        await alignIDS.push(item.id);
      });

      const body = {
        limit: 0,
        offset: 0,
        date_from: this.dateFrom,
        date_to: this.dateFrom,
        trans_id: alignIDS,
      };

      if (datas != 0) {
        try {
          const response = await Services.transactionSyncToWirelessAll(body);

          if (response.status === 201 || response.status === 204) {
            this.closeMessageDialog();
            await this.playData();

            this.$infoBar({
              type: "success",
              text: "Sync and Wireless has been aligned.",
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "Server Error!",
            });
          }
        } catch (error) {
          this.closeMessageDialog();

          if (!error.response) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            if (error.response.data) {
              if (error.response.data.detail) {
                if (error.response.data.detail.code) {
                  if (error.response.data.detail.code === "23503") {
                    this.$infoBar({
                      type: "error",
                      text: "Please align Shift Wireless and Shift Sync first.",
                    });
                  }
                }
              }
            }
          }
        }
      } else {
        this.$infoBar({
          type: "error",
          text: "No Data of Not Align Transactions between Sync and Wireless",
        });
      }

      this.messageLoading = await false;
    },
    async downloadPDF() {
      this.$store.dispatch("startLoading");

      let items = [];

      try {
        const response = (
          await Services.getTransactionWirelessAndSync({
            search: this.queryParams.search,
            transaction_id: this.queryParams.transaction_id,
            offset: 0,
            type: this.queryParams.type,
            aligned: this.queryParams.aligned,
            date_from: this.queryParams.date_from,
            date_to: this.queryParams.date_to,
          })
        ).data;

        items = response.data;
      } catch (error) {}

      let doc = new JsPdf("l", "pt", "a4");

      doc.setFontSize(15);
      doc.setFontType("bold");
      doc.text(this.title + " Report", 410, 30, { align: "center" });

      let headers = [
        [
          "Merchant Code",
          "Device Serial",
          "Branch",
          "TRX #",
          "Date",
          "Time",
          "Trace No. (W)",
          "Card No. (W)",
          "Type (W)",
          "Amount (W)",
          "Trace No. (S)",
          "Card No. (S)",
          "Type (S)",
          "Amount (S)",
          "Discrepancy",
          "Cashier Name",
        ],
      ];

      let data = [];

      items.forEach((item) => {
        let theData = [
          item.merchant,
          item.device_serial,
          item.terminal.toUpperCase(),
          item.transaction_no,
          this.$dateFormat(item.transaction_date, "YYYY-MM-DD"),
          this.$timeFormat(item.transaction_time, "HH:mm:ss"),
          item.trace_no_wireless === null ? "--" : item.trace_no_wireless,
          item.card_no_wireless === null ? "--" : item.card_no_wireless,
          item.type_wireless === null ? "--" : item.type_wireless.toUpperCase(),
          item.card_amount_wireless === null
            ? "--"
            : this.numberWithCommas(item.card_amount_wireless.toFixed(2)),
          item.trace_no_sync === null ? "--" : item.trace_no_sync,
          item.card_no_sync === null ? "--" : item.card_no_sync,
          item.type_sync === null ? "--" : item.type_sync.toUpperCase(),
          item.card_amount_sync === null
            ? "--"
            : this.numberWithCommas(item.card_amount_sync.toFixed(2)),
          item.discrepancy === null
            ? "--"
            : this.numberWithCommas(item.discrepancy.toFixed(2)),
          item.cashier_name ? item.cashier_name.toUpperCase() : "--",
        ];
        data.push(theData);
      });

      doc.autoTable({
        didParseCell: (data) => {
          let col = data.column.index;
          if (col === 3 || col === "3" || col === 11 || col === "11") {
            data.table.styles.headStyles.halign = "center";
          } else if (col === 12 || col === "12" || col === 8 || col === "8") {
            data.table.styles.headStyles.halign = "right";
          } else {
            data.table.styles.headStyles.halign = "left";
          }
        },
        head: headers,
        body: data,
        startY: 60,
        margin: {
          left: 12,
        },
        theme: "grid",
        tableWidth: 880,
        cellWidth: "wrap",
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 1,
        },
        showHead: "everyPage",
        tableLineColor: 200,
        tableLineWidth: 0,
        columnStyles: {
          0: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          1: { cellWidth: "auto", lineColor: "black", textColor: [0, 0, 0] },
          2: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          3: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          4: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "center",
          },
          5: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          6: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          7: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          8: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          9: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          10: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
          },
          11: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          12: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          13: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "right",
          },
          14: {
            cellWidth: "auto",
            lineColor: "black",
            textColor: [0, 0, 0],
            halign: "left",
          },
        },
        styles: {
          overflow: "linebreak",
          cellWidth: "wrap",
          fontSize: 7,
          valign: "middle",
        },
      });

      let pageCount = doc.internal.getNumberOfPages();
      for (let i = 0; i < pageCount; i++) {
        doc.setFontType("normal");
        doc.setFontSize(10);
        doc.setPage(i);
        doc.text(
          395,
          580,
          "Page" +
            " " +
            doc.internal.getCurrentPageInfo().pageNumber +
            " " +
            "of" +
            " " +
            pageCount
        );
      }
      doc.save(this.title + ".pdf");

      this.$store.dispatch("endLoading");
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.clsScroll {
  width: auto;
  overflow-x: scroll;
  overflow-y: auto;
}
</style>
